import { useCallback, useEffect, useRef } from "react";
import { playSound, stopSound } from "../utils/gameAudio";

/**
 * Play the HoL user-wheel spinning sound once per spin on player and spectator screens.
 * The host starts this track locally; these clients only learn about the spin from wheel phase.
 */
export default function useHolWheelSpinSound({ sounds, wheel }) {
  const audioRef = useRef(null);
  const playedTokenRef = useRef(null);

  const stopSpin = useCallback(() => {
    stopSound(audioRef.current);
    audioRef.current = null;
  }, []);

  const phase = wheel?.phase || null;
  const token = phase === "spinning" ? wheel?.token ?? null : null;

  useEffect(() => {
    if (phase !== "spinning" || token == null) {
      playedTokenRef.current = null;
      stopSpin();
      return;
    }
    if (playedTokenRef.current === token) return;
    const cfg = sounds?.spinning_sound;
    if (!cfg?.audio_url) return;
    playedTokenRef.current = token;
    stopSpin();
    audioRef.current = playSound(cfg.audio_url, {
      volume: cfg.volume ?? 1,
      loop: false,
    });
  }, [phase, token, sounds, stopSpin]);

  useEffect(() => () => stopSpin(), [stopSpin]);

  return stopSpin;
}
